import { render, staticRenderFns } from "./WOverlay.vue?vue&type=template&id=729a9d0c&scoped=true&"
import script from "./WOverlay.vue?vue&type=script&setup=true&lang=js&"
export * from "./WOverlay.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729a9d0c",
  null
  
)

export default component.exports